import React from 'react';

import '../../../../../scss/crm/main.scss';

export default function Styles(): React.ReactNode {
    return <></>;
}
